const initialState = {
  customReports: [],
  isFetchingCustomReports: false,

  customReportToViewId: null,

  isFetchingCustomReportParams: false,
  customReportParams: null,

  isCustomReportRunInProgress: false,
  customReportData: null,

  customReportSetReports: [],
  isFetchingCustomReportSet: false,

  queryParams: {},
};

export default initialState;
